import { getFirestore, collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';

export const verifyCode = async (code, userId) => {
  try {
    const db = getFirestore();
    const codesRef = collection(db, 'verificationCodes');
    const q = query(codesRef, where('code', '==', code), where('used', '==', false));
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      throw new Error('Invalid or already used verification code');
    }

    const codeDoc = querySnapshot.docs[0];
    const codeRef = doc(db, 'verificationCodes', codeDoc.id);

    await updateDoc(codeRef, {
      used: true,
      usedBy: userId,
      usedAt: new Date()
    });

    return true;
  } catch (error) {
    console.error('Error verifying code:', error);
    throw error;
  }
};

export const checkCodeValidity = async (code) => {
  try {
    const db = getFirestore();
    const codesRef = collection(db, 'verificationCodes');
    const q = query(codesRef, where('code', '==', code), where('used', '==', false));
    const querySnapshot = await getDocs(q);

    return !querySnapshot.empty;
  } catch (error) {
    console.error('Error checking code validity:', error);
    throw error;
  }
}; 